
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService, TimeApiService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke352aRequest, Sgke352aResponse, Sgke352aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke352aService {

  /**
   * コンストラクタ
   * @param {Sgke352aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {TimeApiService} timeApiService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke352aService
   */
  constructor(
    public service: Sgke352aService,
    public apiCommonService: ApiCommonService,
    private timeApiService: TimeApiService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE352A_供給再開作業割当検索API呼び出し
   * @param {Sgke352aRequest} request 
   * @returns {Observable<Sgke352aResponse>}
   * @memberof UsedSgke352aService
   */
  public doSgke352a(request: Sgke352aRequest): Observable<Sgke352aResponse> {
    //日付のフォーマットをYYMMDDに変更
    this.apiCommonService.convertElementInObject(request, Object.prototype.toString.call(new Date()), this.timeApiService.convertDateToString);
    return this.service.sgke352aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE352A');
          return throwError(err.message);
        })
      );
  }

}
